<div class="fieldset-container">
  <div class="title">{{ title | translate }}</div>
  <div class="body">
    <ng-content></ng-content>
  </div>
</div>
